import {
    FORM_INPUT_ON_CHANGE,
    FORM_CLEAR_ERRORS,
    FORM_ON_ERRORS,
    FORM_RESET_STATE,
    FORM_PROCESSING,
    FORM_SET_GLOBAL_SETTINGS,
    FORM_SET_ERROR_ORIGIN,
    SAVE_PASSWORD_STRENGTH
} from '../actions/ActionTypes';

/**
 * Empty initial state so we can clear all form data the first times forms are loaded
 */
const initialState = {
    processing: false,
    passwordStrength: 0
};

export function formReducer(state = initialState, action) {

    switch(action.type) {

        case FORM_PROCESSING:
            return Object.assign({}, state, { processing: action.processing });

        case FORM_ON_ERRORS:
            return Object.assign({}, state, { errors: Object.assign(state.errors || {}, action.errors) });

        case FORM_INPUT_ON_CHANGE:
            const valObj = {};
            valObj[action.e.currentTarget.name] = action.e.currentTarget.value;
            return Object.assign({}, state, valObj);

        case FORM_CLEAR_ERRORS:
            return Object.assign({}, state, { errors: {} });

        case FORM_SET_GLOBAL_SETTINGS:
            return Object.assign({}, state, { globalSettings: action.globalSettings });

        case FORM_RESET_STATE:
            return Object.assign({}, initialState, { globalSettings: state.globalSettings });
        
        case FORM_SET_ERROR_ORIGIN:
            return Object.assign({}, state, { formErrorOrigin: action.formErrorOrigin});
        case SAVE_PASSWORD_STRENGTH:
            return Object.assign({}, state, { passwordStrength: action.payload});
        default:
            return state;

    }

}